export default "__VITE_ASSET___DYIlRfa__"